export default "__VITE_ASSET__6VsCbAJ4__"